import { useContext } from 'react';
import i18n from '../../../../i18n';
import { TempLanguageContext } from '../store/context/TempLanguageProvider';

interface TempLanguage {
  tempLanguage: string;
  setTempLanguage: (language: string) => void;
}

/**
 * A hook that provides the ability to temporarily change the language of the platoform.
 * This hook should be used with the TempLanguageProvider component.
 */
const useTempLanguage = (): TempLanguage => {
  const tempLanguageContext = useContext(TempLanguageContext);

  /**
   * A temporarily language will be set while the provider is rendered
   * @param lang The language to be set temporarily
   */
  const setTempLanguage = (lang: string) => {
    tempLanguageContext?.setTempLanguage?.(lang);
  };

  return {
    setTempLanguage,
    tempLanguage: tempLanguageContext?.tempLanguage || i18n.language,
  };
};

export default useTempLanguage;
